<div class="bg-card p-0 m-0">
  <div class="flex flex-col justify-content-between">
    <h2 class="text-2xl font-bold">{{ 'Logout all devices' | transloco }}</h2>
  </div>

  <div class="flex flex-col gap-5 align-center justify-center overflow-hidden" mat-dialog-content>
    <div class="text-secondary text-lg leading-normal">
      {{ 'All unpublished reports & offline snags will be lost' | transloco }}
    </div>

    <mat-icon
      *ngIf="hideForm"
      class="icon-size-20 self-center"
      color="warn"
      svgIcon="mat_outline:front_hand"
    ></mat-icon>

    <!-- Alert -->
    <fuse-alert
      *ngIf="showAlert"
      [@shake]="alert.type === 'error'"
      [appearance]="'outline'"
      [showIcon]="false"
      [type]="alert.type"
      class="mt-2 -mb-4 capitalize-sentence"
    >
      {{ alert.message | transloco }}
    </fuse-alert>

    <!-- Sign in form -->

    <form #logoutNgForm="ngForm" [formGroup]="logoutForm" class="mt-2">
      <!-- Password field -->
      <mat-form-field class="w-full">
        <mat-label>{{ 'password' | transloco }}</mat-label>
        <input
          #passwordField
          [formControlName]="'password'"
          id="password"
          matInput
          type="password"
        />
        <button
          (click)="
            passwordField.type === 'password'
              ? (passwordField.type = 'text')
              : (passwordField.type = 'password')
          "
          mat-icon-button
          matSuffix
          type="button"
        >
          <mat-icon
            *ngIf="passwordField.type === 'password'"
            [svgIcon]="'heroicons_solid:eye'"
            class="icon-size-5"
          ></mat-icon>
          <mat-icon
            *ngIf="passwordField.type === 'text'"
            [svgIcon]="'heroicons_solid:eye-off'"
            class="icon-size-5"
          ></mat-icon>
        </button>
        <mat-error>
          {{ 'password is required' | transloco }}
        </mat-error>
      </mat-form-field>

      <div class="text-secondary">
        <p>
          {{ 'Attempts left: ' | transloco }}<span>{{ attempts }}</span>
        </p>
      </div>

      <!-- Submit button -->
      <div class="flex flex-row gap-2 justify-end">
        <button
          (click)="logout()"
          [color]="'warn'"
          [disabled]="logoutForm.disabled || isUploadingInProgress"
          autofocus
          class="mat-dense"
          [ngClass]="isUploadingInProgress ? 'logout' : ''"
          id="logOutButtonId"
          mat-flat-button
          [loadingState]="logoutForm.disabled"
          appLoadingButton
        >
          {{ 'Logout' | transloco }}
        </button>
        <button mat-flat-button (click)="onDismiss()" class="mat-dense" mat-buttonid="close">
          {{ 'Cancel' | transloco }}
        </button>
      </div>
    </form>
  </div>
</div>
